var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTablePlus = function SvgTablePlus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_53_3386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 64,
    height: 64,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 35.5,
    width: 63,
    height: 63,
    rx: 19.5,
    stroke: "#ECECEC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8298 74.3488C63.7228 74.3488 63.6373 74.3488 63.5446 74.3488C62.3823 74.3488 61.2272 74.3417 60.0649 74.3488C59.0952 74.3559 58.3393 73.9637 57.8544 73.1223C57.3696 72.2667 57.4337 71.411 57.94 70.5839C58.2894 70.0134 58.6174 69.443 58.9668 68.8797C59.4303 68.131 59.6442 67.3252 59.6442 66.4482C59.6371 65.5569 59.6371 64.6584 59.6442 63.7671C59.6941 60.3231 62.0686 57.4138 65.4342 56.6723C69.5841 55.7524 73.7127 58.6189 74.2831 62.8188C74.3402 63.2252 74.3473 63.6388 74.3544 64.0452C74.3687 65.0292 74.3615 66.0132 74.3901 66.9972C74.4115 67.6532 74.6539 68.2593 74.9962 68.8226C75.3741 69.4501 75.752 70.0705 76.1228 70.698C76.9856 72.1811 76.1584 73.9923 74.4756 74.3131C74.2902 74.3488 74.0977 74.3488 73.9123 74.3488C72.7643 74.3488 71.6092 74.3488 70.4612 74.3488C70.3756 74.3488 70.2829 74.3488 70.1759 74.3488C70.1332 75.3898 69.7267 76.2312 68.9067 76.8658C68.2721 77.3507 67.5519 77.5432 66.7533 77.4933C65.5197 77.4149 63.9368 76.4166 63.8298 74.3488ZM67.0029 72.2524C69.2989 72.2524 71.5878 72.2524 73.8838 72.2453C74.0335 72.2453 74.2189 72.1882 74.3116 72.0884C74.4542 71.9387 74.3259 71.7675 74.2332 71.6178C73.8909 71.0474 73.5487 70.4769 73.2064 69.9136C72.6217 68.9367 72.2866 67.8885 72.2723 66.7477C72.2652 65.8278 72.2794 64.908 72.2581 63.9882C72.2509 63.596 72.2295 63.1967 72.1511 62.8116C71.5664 59.9737 68.9495 58.1982 66.0759 58.6759C63.7656 59.0539 61.8974 61.0861 61.7762 63.4106C61.7263 64.359 61.7334 65.3144 61.7477 66.2628C61.7762 67.6675 61.4268 68.951 60.671 70.1347C60.343 70.6552 60.0292 71.1828 59.7226 71.7176C59.5515 72.01 59.6799 72.2382 60.0221 72.2524C60.0863 72.2524 60.1505 72.2524 60.2218 72.2524C62.475 72.2524 64.7425 72.2524 67.0029 72.2524ZM65.9761 74.3559C65.969 74.9549 66.4681 75.4255 67.0385 75.397C67.6161 75.3684 68.0796 74.8836 68.0225 74.3559C67.3451 74.3559 66.6677 74.3559 65.9761 74.3559Z",
    fill: "#323232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_53_3386",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 15,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_53_3386"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_3386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_53_3386",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTablePlus);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;